export default __webpack_public_path__ + "Winterkomplettrad Cashback-Aktion 2026 -Anbieter_FINAL.pdf";